export default __webpack_public_path__ + "static/media/GreenFrame08.aabaca35.png";